import { AfterViewInit, Component, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../_services/auth.service';
import { AlertService } from '../../_services/alert.service';

@Component({
  templateUrl: 'forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, AfterViewInit {
  recoverPwdForm: FormGroup;
  submitted = false;
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    public authService: AuthService,
    private renderer: Renderer2
  ) {
  }

  ngOnInit() {
    this.recoverPwdForm = this.formBuilder.group({
      email: ['', Validators.required]
    });
    this.renderer.addClass(document.body, 'authentication-pages');
  }

  ngAfterViewInit(): void {
    const footerElement = document.getElementsByClassName('footer');
    Array.from(footerElement).forEach((el) => {
      this.renderer.removeClass(el, 'footer-static');
      this.renderer.addClass(el, 'fixed-bottom');
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.recoverPwdForm.controls;
  }

  tryRecover() {
    this.submitted = true;
    this.loading = true;

    // stop here if form is invalid
    if (this.recoverPwdForm.invalid) {
      this.loading = false;
      return;
    }

    this.authService.doRecoverPassword(this.f.email.value).then(
      res => {    
        this.submitted = false;
        this.loading = false;
        this.alertService.success(res.message);
      },
      err => {
        this.submitted = false;
        this.loading = false;
        this.alertService.error(err.message);
      }
    );
  }
}
